import { Component, Input} from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PartnerAnalysisGroup2 } from 'src/app/assabil-kernel/models/entities/control-tables/partner-analysis-group2';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';



@Component({
    selector: 'partner-analysis-group2-lov',
    templateUrl: './partner-analysis-group2-lov.component.html',
    styleUrls: ['./partner-analysis-group2-lov.component.scss']
})


export class PartnerAnalysisGroup2LovComponent extends GenericLovComponent   {

    @Input() code         : string; 
    @Input() name         : string; 

    partnerAnalysisGroup2s: PartnerAnalysisGroup2[] = [];

    columns = [
        {  prop: 'partnerAnalysisGroup2Code', name: 'Code'},
        {  prop: 'name', name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<PartnerAnalysisGroup2LovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "partnerAnalysisGroup2";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.partnerAnalysisGroup2s = result;
    })
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
closeModal(partnerAnalysisGroup2 : PartnerAnalysisGroup2){
    this.dialogRef.close(partnerAnalysisGroup2);
}
//----------------------------------------------------------------------


}
